import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { signIn } from "../services/authService";

interface SecureRouteProps {
  children: React.ReactNode;
}

const SecureRoute: React.FC<SecureRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const timer = setTimeout(() => {
        signIn();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, isLoading]);

  // Show a loading indicator while checking authentication
  if (isLoading || !isAuthenticated) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-primary mx-auto mb-4"></div>
          <p className="text-gray-600">
            {isLoading
              ? "Checking authentication..."
              : "Redirecting to login..."}
          </p>
        </div>
      </div>
    );
  }

  // If authenticated, render the protected component
  return <>{children}</>;
};

export default SecureRoute;
